import React, { useState } from "react";
import { View, StyleSheet } from "react-native";

import ImageComponent from "../../../common/ImageComponent";
import { isWeb } from "../../../../../helpers/utils";
import DesktopIntegrationEmailSent from "../../onboarding/desktop/DesktopIntegrationEmailSent";
import DownloadButtons from "./DownloadButtons";
import DownloadStarted from "./DownloadStarted";

export default function Download({ controller, showAccounts = () => {} }) {
  const [downloadInProgress, setDownloadInProgress] = useState(false);

  const goBack = () => {
    controller.goBack();
  };

  return (
    <>
      {downloadInProgress ? (
        isWeb ? (
          <DownloadStarted
            controller={controller}
            goToStep={goBack}
            showAccounts={showAccounts}
          />
        ) : (
          <DesktopIntegrationEmailSent
            controller={controller}
            goToStep={goBack}
            skipHeader={true}
            isFromCard={true}
          />
        )
      ) : (
        <View>
          <View
            style={{
              alignItems: "center",
              marginTop: 82,
            }}
          >
            <ImageComponent
              image={require("../../../../../assets/integrations/desktopBig.png")}
              style={styles.desktopIcon}
            />
          </View>

          <DownloadButtons
            controller={controller}
            onDownload={() => setDownloadInProgress(true)}
          />
        </View>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  desktopIcon: {
    width: 279,
    height: 266,
  },
});
